// @ts-nocheck

import * as Apollo from "@apollo/client";

import gql from "graphql-tag";
import * as APITypes from "../../apiTypes";
import { PaymentFragmentDoc } from "./fragments.generated";

const defaultOptions = {} as const;
export type WorkerTimeStatsModelFragment = {
  antepenultimateMontTotalHours?: string | null;
  previousMonthTotalHours?: string | null;
  totalHoursInThisMonth?: string | null;
};

export type AutoCompleteResponseFragment = {
  address?: string | null;
  city?: string | null;
  country?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  postalCode?: string | null;
};

export type ReferralFragment = { code: string; providerReward: number; value: number };

export type PropertyFragment = {
  city: string;
  doorCode?: string | null;
  floorArea: number;
  id: string;
  isCustomerDefault: boolean;
  localizationId?: string | null;
  name: string;
  notes?: string | null;
  postalOrZipCode: string;
  streetAddress1: string;
  streetAddress2?: string | null;
  type: APITypes.ApartmentType;
};

export type CustomerMetadataFragment = {
  invoiceData?: {
    country?: string | null;
    city?: string | null;
    email?: string | null;
    line1?: string | null;
    line2?: string | null;
    name: string;
    postal_code?: string | null;
    state?: string | null;
    taxIdentification?: string | null;
  } | null;
  properties?: Array<{
    city: string;
    doorCode?: string | null;
    floorArea: number;
    id: string;
    isCustomerDefault: boolean;
    localizationId?: string | null;
    name: string;
    notes?: string | null;
    postalOrZipCode: string;
    streetAddress1: string;
    streetAddress2?: string | null;
    type: APITypes.ApartmentType;
  }> | null;
};

export type WorkerAddressFragment = {
  city: string;
  extraInformation?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  postalOrZipCode: string;
  streetAddress1: string;
  streetAddress2?: string | null;
};

export type WorkerPayoutsFragment = {
  balance?: number | null;
  bankAccountId?: string | null;
  connectedAccountId?: string | null;
  extraInformation?: Array<string> | null;
  onboardingStatus?: APITypes.OnboardingStatusEnum | null;
  bankAccountName?: string | null;
};

export type WorkerWorkingHoursFragment = { endTime?: string | null; startTime?: string | null };

export type PayoutFragment = {
  address?: string | null;
  amount: number;
  bankName?: string | null;
  createdAt: string;
  currency: string;
  customerName?: string | null;
  description?: string | null;
  id: string;
  type: APITypes.PayoutsHistoryType;
};

export type GetUserProfileQueryVariables = APITypes.Exact<{
  isCustomerProfile: APITypes.Scalars["Boolean"]["input"];
}>;

export type GetUserProfileQuery = {
  getMyProfile: {
    id: string;
    profileInformation: {
      dateOfBirth?: string | null;
      description?: string | null;
      email: string;
      firstName: string;
      image?: string | null;
      lastName: string;
      phone: string;
      profileType: APITypes.ProfileTypeEnum;
      pushNotifications?: boolean | null;
      newsletterNotifications?: boolean | null;
      smsNotifications?: boolean | null;
      jobOffersEnabled?: boolean | null;
      payoutsEnabled?: boolean | null;
      customerMetadata?: {
        invoiceData?: {
          country?: string | null;
          city?: string | null;
          email?: string | null;
          line1?: string | null;
          line2?: string | null;
          name: string;
          postal_code?: string | null;
          state?: string | null;
          taxIdentification?: string | null;
        } | null;
        properties?: Array<{
          city: string;
          doorCode?: string | null;
          floorArea: number;
          id: string;
          isCustomerDefault: boolean;
          localizationId?: string | null;
          name: string;
          notes?: string | null;
          postalOrZipCode: string;
          streetAddress1: string;
          streetAddress2?: string | null;
          type: APITypes.ApartmentType;
        }> | null;
      } | null;
      workerMetadata?: {
        experience?: string | null;
        trainingVerificationStatus: APITypes.VerificationStatusEnum;
        address?: {
          city: string;
          extraInformation?: string | null;
          latitude?: number | null;
          longitude?: number | null;
          postalOrZipCode: string;
          streetAddress1: string;
          streetAddress2?: string | null;
        } | null;
        payoutsMetadata?: {
          balance?: number | null;
          bankAccountId?: string | null;
          connectedAccountId?: string | null;
          extraInformation?: Array<string> | null;
          onboardingStatus?: APITypes.OnboardingStatusEnum | null;
          bankAccountName?: string | null;
        } | null;
        stats?: { avgReview?: string | null; totalHoursInThisMonth?: string | null } | null;
        workerDayOffs?: Array<{
          endDate?: string | null;
          id?: string | null;
          startDate?: string | null;
        }> | null;
        workerWorkingHours?: {
          friday?: { endTime?: string | null; startTime?: string | null } | null;
          monday?: { endTime?: string | null; startTime?: string | null } | null;
          saturday?: { endTime?: string | null; startTime?: string | null } | null;
          sunday?: { endTime?: string | null; startTime?: string | null } | null;
          thursday?: { endTime?: string | null; startTime?: string | null } | null;
          tuesday?: { endTime?: string | null; startTime?: string | null } | null;
          wednesday?: { endTime?: string | null; startTime?: string | null } | null;
        } | null;
      } | null;
    };
  };
};

export type GetLocalizationByCoordinatesQueryVariables = APITypes.Exact<{
  latitude: APITypes.Scalars["Float"]["input"];
  longitude: APITypes.Scalars["Float"]["input"];
}>;

export type GetLocalizationByCoordinatesQuery = {
  getLocalizationByCoordinates: {
    id?: string | null;
    name?: string | null;
    timezone?: string | null;
  };
};

export type GetListLocalizationWithPaginationQueryVariables = APITypes.Exact<{
  limit: APITypes.Scalars["Int"]["input"];
  page: APITypes.Scalars["Int"]["input"];
}>;

export type GetListLocalizationWithPaginationQuery = {
  listLocalizationWithPagination: {
    items: Array<{ id?: string | null; name?: string | null; timezone?: string | null }>;
  };
};

export type GetListCountriesQueryVariables = APITypes.Exact<{ [key: string]: never }>;

export type GetListCountriesQuery = {
  listCountries: Array<{
    countryCode: string;
    currency: string;
    id: string;
    locale: string;
    name: string;
  }>;
};

export type CheckIfProfileExistsQueryVariables = APITypes.Exact<{ [key: string]: never }>;

export type CheckIfProfileExistsQuery = { checkIfProfileExists: boolean };

export type ListPayoutHistoryQueryVariables = APITypes.Exact<{ [key: string]: never }>;

export type ListPayoutHistoryQuery = {
  listPayoutsHistory: Array<{
    address?: string | null;
    amount: number;
    bankName?: string | null;
    createdAt: string;
    currency: string;
    customerName?: string | null;
    description?: string | null;
    id: string;
    type: APITypes.PayoutsHistoryType;
  }>;
};

export type ListPaymentHistoryQueryVariables = APITypes.Exact<{ [key: string]: never }>;

export type ListPaymentHistoryQuery = {
  listPaymentsHistory: Array<{
    amount: number;
    appliedDiscount: number;
    currency: string;
    id: string;
    paymentMethodId?: string | null;
    paymentUpdateDate?: string | null;
    status: APITypes.PaymentStatus;
    stripePaymentNextStep?:
      | {
          clientSecret: string;
          paymentIntentId: string;
          redirectUrl: string;
          type: APITypes.PaymentActionType;
        }
      | {
          clientSecret: string;
          paymentIntentId: string;
          stripeSdkData: string;
          type: APITypes.PaymentActionType;
        }
      | null;
  }>;
};

export type GetMyReferralQueryVariables = APITypes.Exact<{ [key: string]: never }>;

export type GetMyReferralQuery = {
  myReferral: { code: string; providerReward: number; value: number };
};

export type GetAutoCompleteAddressQueryVariables = APITypes.Exact<{
  payload: APITypes.GenerateAutocompleteForAddressInput;
}>;

export type GetAutoCompleteAddressQuery = {
  generateAutocompleteForAddress: Array<{
    address?: string | null;
    city?: string | null;
    country?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    postalCode?: string | null;
  }>;
};

export type GetWorkerTimeStatsQueryVariables = APITypes.Exact<{
  endDate: APITypes.Scalars["DateTime"]["input"];
  startDate: APITypes.Scalars["DateTime"]["input"];
}>;

export type GetWorkerTimeStatsQuery = {
  getWorkerTimeStats: {
    antepenultimateMontTotalHours?: string | null;
    previousMonthTotalHours?: string | null;
    totalHoursInThisMonth?: string | null;
  };
};

export type RegisterAccountMutationVariables = APITypes.Exact<{
  email?: APITypes.InputMaybe<APITypes.Scalars["String"]["input"]>;
  phoneNumber: APITypes.Scalars["String"]["input"];
}>;

export type RegisterAccountMutation = { registerAccountWithPhoneNumber: string };

export type RegisterAccountWithGoogleMutationVariables = APITypes.Exact<{
  data: APITypes.RegisterAccountWithGoogleInput;
}>;

export type RegisterAccountWithGoogleMutation = { registerAccountWithGoogle: string };

export type RegisterAccountWithFacebookMutationVariables = APITypes.Exact<{
  data: APITypes.RegisterAccountWithFacebookInput;
}>;

export type RegisterAccountWithFacebookMutation = { registerAccountWithFacebook: string };

export type LoginSendSmsCodeMutationVariables = APITypes.Exact<{
  phone_number: APITypes.Scalars["String"]["input"];
}>;

export type LoginSendSmsCodeMutation = { startLoginChallenge: boolean };

export type CreateWorkerProfileMutationVariables = APITypes.Exact<{
  data: APITypes.CreateWorkerProfileInput;
}>;

export type CreateWorkerProfileMutation = { createWorkerProfile: boolean };

export type CreateCustomerProfileMutationVariables = APITypes.Exact<{
  data: APITypes.CreateCustomerProfileInput;
}>;

export type CreateCustomerProfileMutation = { createCustomerProfile: boolean };

export type AssignWorkerToLocalizationMutationVariables = APITypes.Exact<{
  payload: APITypes.AssignWorkerToLocalizationsDto;
}>;

export type AssignWorkerToLocalizationMutation = { assignWorkerToLocalization: boolean };

export type UpdateWorkerProfileMutationVariables = APITypes.Exact<{
  data: APITypes.UpdateWorkerProfileInput;
}>;

export type UpdateWorkerProfileMutation = { updateWorkerProfile: boolean };

export type UploadDocumentForVerificationMutationVariables = APITypes.Exact<{
  data: APITypes.UploadDocumentForVerificationInput;
}>;

export type UploadDocumentForVerificationMutation = { uploadDocumentForVerification: boolean };

export type UpdateCustomerProfileMutationVariables = APITypes.Exact<{
  data: APITypes.UpdateCustomerProfileInput;
}>;

export type UpdateCustomerProfileMutation = { updateCustomerProfile: boolean };

export type UpdateProfileImageMutationVariables = APITypes.Exact<{
  data: APITypes.UpdateProfileImageInput;
}>;

export type UpdateProfileImageMutation = { updateProfileImage: boolean };

export type AddWorkerBankAccountMutationVariables = APITypes.Exact<{
  data: APITypes.AddBankAccountInput;
}>;

export type AddWorkerBankAccountMutation = { addWorkerBankAccount: boolean };

export type RemoveWorkerBankAccountMutationVariables = APITypes.Exact<{ [key: string]: never }>;

export type RemoveWorkerBankAccountMutation = { removeWorkerBankAccount: boolean };

export type SubmitWorkerPayoutMutationVariables = APITypes.Exact<{
  data: APITypes.SubmitPayoutInput;
}>;

export type SubmitWorkerPayoutMutation = { submitWorkerPayoutPayout: boolean };

export type DeleteProfileMutationVariables = APITypes.Exact<{ [key: string]: never }>;

export type DeleteProfileMutation = { deleteProfile: boolean };

export type AttachDeviceToUserMutationVariables = APITypes.Exact<{
  data: APITypes.PushNotificationDeviceInput;
}>;

export type AttachDeviceToUserMutation = { attachDeviceToUser: boolean };

export type DetachDeviceFromUserMutationVariables = APITypes.Exact<{
  data: APITypes.DetachPushNotificationDeviceInput;
}>;

export type DetachDeviceFromUserMutation = { detachDeviceFromUser: boolean };

export const WorkerTimeStatsModelFragmentDoc = gql`
    fragment WorkerTimeStatsModel on WorkerTimeStatsModel {
  antepenultimateMontTotalHours
  previousMonthTotalHours
  totalHoursInThisMonth
}
    `;
export const AutoCompleteResponseFragmentDoc = gql`
    fragment AutoCompleteResponse on AutoCompleteResponseModel {
  address
  city
  country
  latitude
  longitude
  postalCode
}
    `;
export const ReferralFragmentDoc = gql`
    fragment Referral on Referral {
  code
  providerReward
  value
}
    `;
export const PropertyFragmentDoc = gql`
    fragment Property on CustomerPropertyModel {
  city
  doorCode
  floorArea
  id
  isCustomerDefault
  localizationId
  name
  notes
  postalOrZipCode
  streetAddress1
  streetAddress2
  type
}
    `;
export const CustomerMetadataFragmentDoc = gql`
    fragment CustomerMetadata on CustomerMetadata {
  invoiceData {
    country
    city
    email
    line1
    line2
    name
    postal_code
    state
    taxIdentification
  }
  properties {
    ...Property
  }
}
    ${PropertyFragmentDoc}`;
export const WorkerAddressFragmentDoc = gql`
    fragment WorkerAddress on WorkerAddressModel {
  city
  extraInformation
  latitude
  longitude
  postalOrZipCode
  streetAddress1
  streetAddress2
}
    `;
export const WorkerPayoutsFragmentDoc = gql`
    fragment WorkerPayouts on PayoutsMetadataModel {
  balance
  bankAccountId
  connectedAccountId
  extraInformation
  onboardingStatus
  bankAccountName
}
    `;
export const WorkerWorkingHoursFragmentDoc = gql`
    fragment WorkerWorkingHours on WorkerWorkingHoursProfileHelper {
  endTime
  startTime
}
    `;
export const PayoutFragmentDoc = gql`
    fragment Payout on Payout {
  address
  amount
  bankName
  createdAt
  currency
  customerName
  description
  id
  type
}
    `;
export const GetUserProfileDocument = gql`
    query GetUserProfile($isCustomerProfile: Boolean!) {
  getMyProfile {
    id
    profileInformation {
      customerMetadata @include(if: $isCustomerProfile) {
        ...CustomerMetadata
      }
      dateOfBirth
      description
      email
      firstName
      image
      lastName
      phone
      profileType
      pushNotifications
      newsletterNotifications
      smsNotifications
      jobOffersEnabled @skip(if: $isCustomerProfile)
      payoutsEnabled @skip(if: $isCustomerProfile)
      workerMetadata @skip(if: $isCustomerProfile) {
        address {
          ...WorkerAddress
        }
        experience
        payoutsMetadata {
          ...WorkerPayouts
        }
        stats {
          avgReview
          totalHoursInThisMonth
        }
        trainingVerificationStatus
        workerDayOffs {
          endDate
          id
          startDate
        }
        workerWorkingHours {
          friday {
            ...WorkerWorkingHours
          }
          monday {
            ...WorkerWorkingHours
          }
          saturday {
            ...WorkerWorkingHours
          }
          sunday {
            ...WorkerWorkingHours
          }
          thursday {
            ...WorkerWorkingHours
          }
          tuesday {
            ...WorkerWorkingHours
          }
          wednesday {
            ...WorkerWorkingHours
          }
        }
      }
    }
  }
}
    ${CustomerMetadataFragmentDoc}
${WorkerAddressFragmentDoc}
${WorkerPayoutsFragmentDoc}
${WorkerWorkingHoursFragmentDoc}`;

/**
 * __useGetUserProfileQuery__
 *
 * To run a query within a React component, call `useGetUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileQuery({
 *   variables: {
 *      isCustomerProfile: // value for 'isCustomerProfile'
 *   },
 * });
 */
export function useGetUserProfileQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables> &
    ({ variables: GetUserProfileQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(
    GetUserProfileDocument,
    options,
  );
}
export function useGetUserProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(
    GetUserProfileDocument,
    options,
  );
}
export function useGetUserProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserProfileQuery, GetUserProfileQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(
    GetUserProfileDocument,
    options,
  );
}
export type GetUserProfileQueryHookResult = ReturnType<typeof useGetUserProfileQuery>;
export type GetUserProfileLazyQueryHookResult = ReturnType<typeof useGetUserProfileLazyQuery>;
export type GetUserProfileSuspenseQueryHookResult = ReturnType<
  typeof useGetUserProfileSuspenseQuery
>;
export type GetUserProfileQueryResult = Apollo.QueryResult<
  GetUserProfileQuery,
  GetUserProfileQueryVariables
>;
export const GetLocalizationByCoordinatesDocument = gql`
    query GetLocalizationByCoordinates($latitude: Float!, $longitude: Float!) {
  getLocalizationByCoordinates(latitude: $latitude, longitude: $longitude) {
    id
    name
    timezone
  }
}
    `;

/**
 * __useGetLocalizationByCoordinatesQuery__
 *
 * To run a query within a React component, call `useGetLocalizationByCoordinatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalizationByCoordinatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalizationByCoordinatesQuery({
 *   variables: {
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *   },
 * });
 */
export function useGetLocalizationByCoordinatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLocalizationByCoordinatesQuery,
    GetLocalizationByCoordinatesQueryVariables
  > &
    ({ variables: GetLocalizationByCoordinatesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLocalizationByCoordinatesQuery,
    GetLocalizationByCoordinatesQueryVariables
  >(GetLocalizationByCoordinatesDocument, options);
}
export function useGetLocalizationByCoordinatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLocalizationByCoordinatesQuery,
    GetLocalizationByCoordinatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLocalizationByCoordinatesQuery,
    GetLocalizationByCoordinatesQueryVariables
  >(GetLocalizationByCoordinatesDocument, options);
}
export function useGetLocalizationByCoordinatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetLocalizationByCoordinatesQuery,
        GetLocalizationByCoordinatesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetLocalizationByCoordinatesQuery,
    GetLocalizationByCoordinatesQueryVariables
  >(GetLocalizationByCoordinatesDocument, options);
}
export type GetLocalizationByCoordinatesQueryHookResult = ReturnType<
  typeof useGetLocalizationByCoordinatesQuery
>;
export type GetLocalizationByCoordinatesLazyQueryHookResult = ReturnType<
  typeof useGetLocalizationByCoordinatesLazyQuery
>;
export type GetLocalizationByCoordinatesSuspenseQueryHookResult = ReturnType<
  typeof useGetLocalizationByCoordinatesSuspenseQuery
>;
export type GetLocalizationByCoordinatesQueryResult = Apollo.QueryResult<
  GetLocalizationByCoordinatesQuery,
  GetLocalizationByCoordinatesQueryVariables
>;
export const GetListLocalizationWithPaginationDocument = gql`
    query GetListLocalizationWithPagination($limit: Int!, $page: Int!) {
  listLocalizationWithPagination(limit: $limit, page: $page) {
    items {
      id
      name
      timezone
    }
  }
}
    `;

/**
 * __useGetListLocalizationWithPaginationQuery__
 *
 * To run a query within a React component, call `useGetListLocalizationWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListLocalizationWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListLocalizationWithPaginationQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetListLocalizationWithPaginationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetListLocalizationWithPaginationQuery,
    GetListLocalizationWithPaginationQueryVariables
  > &
    (
      | { variables: GetListLocalizationWithPaginationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetListLocalizationWithPaginationQuery,
    GetListLocalizationWithPaginationQueryVariables
  >(GetListLocalizationWithPaginationDocument, options);
}
export function useGetListLocalizationWithPaginationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetListLocalizationWithPaginationQuery,
    GetListLocalizationWithPaginationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetListLocalizationWithPaginationQuery,
    GetListLocalizationWithPaginationQueryVariables
  >(GetListLocalizationWithPaginationDocument, options);
}
export function useGetListLocalizationWithPaginationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetListLocalizationWithPaginationQuery,
        GetListLocalizationWithPaginationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetListLocalizationWithPaginationQuery,
    GetListLocalizationWithPaginationQueryVariables
  >(GetListLocalizationWithPaginationDocument, options);
}
export type GetListLocalizationWithPaginationQueryHookResult = ReturnType<
  typeof useGetListLocalizationWithPaginationQuery
>;
export type GetListLocalizationWithPaginationLazyQueryHookResult = ReturnType<
  typeof useGetListLocalizationWithPaginationLazyQuery
>;
export type GetListLocalizationWithPaginationSuspenseQueryHookResult = ReturnType<
  typeof useGetListLocalizationWithPaginationSuspenseQuery
>;
export type GetListLocalizationWithPaginationQueryResult = Apollo.QueryResult<
  GetListLocalizationWithPaginationQuery,
  GetListLocalizationWithPaginationQueryVariables
>;
export const GetListCountriesDocument = gql`
    query GetListCountries {
  listCountries {
    countryCode
    currency
    id
    locale
    name
  }
}
    `;

/**
 * __useGetListCountriesQuery__
 *
 * To run a query within a React component, call `useGetListCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetListCountriesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetListCountriesQuery, GetListCountriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetListCountriesQuery, GetListCountriesQueryVariables>(
    GetListCountriesDocument,
    options,
  );
}
export function useGetListCountriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetListCountriesQuery, GetListCountriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetListCountriesQuery, GetListCountriesQueryVariables>(
    GetListCountriesDocument,
    options,
  );
}
export function useGetListCountriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetListCountriesQuery, GetListCountriesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetListCountriesQuery, GetListCountriesQueryVariables>(
    GetListCountriesDocument,
    options,
  );
}
export type GetListCountriesQueryHookResult = ReturnType<typeof useGetListCountriesQuery>;
export type GetListCountriesLazyQueryHookResult = ReturnType<typeof useGetListCountriesLazyQuery>;
export type GetListCountriesSuspenseQueryHookResult = ReturnType<
  typeof useGetListCountriesSuspenseQuery
>;
export type GetListCountriesQueryResult = Apollo.QueryResult<
  GetListCountriesQuery,
  GetListCountriesQueryVariables
>;
export const CheckIfProfileExistsDocument = gql`
    query CheckIfProfileExists {
  checkIfProfileExists
}
    `;

/**
 * __useCheckIfProfileExistsQuery__
 *
 * To run a query within a React component, call `useCheckIfProfileExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfProfileExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfProfileExistsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckIfProfileExistsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CheckIfProfileExistsQuery,
    CheckIfProfileExistsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckIfProfileExistsQuery, CheckIfProfileExistsQueryVariables>(
    CheckIfProfileExistsDocument,
    options,
  );
}
export function useCheckIfProfileExistsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckIfProfileExistsQuery,
    CheckIfProfileExistsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CheckIfProfileExistsQuery, CheckIfProfileExistsQueryVariables>(
    CheckIfProfileExistsDocument,
    options,
  );
}
export function useCheckIfProfileExistsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckIfProfileExistsQuery,
        CheckIfProfileExistsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CheckIfProfileExistsQuery, CheckIfProfileExistsQueryVariables>(
    CheckIfProfileExistsDocument,
    options,
  );
}
export type CheckIfProfileExistsQueryHookResult = ReturnType<typeof useCheckIfProfileExistsQuery>;
export type CheckIfProfileExistsLazyQueryHookResult = ReturnType<
  typeof useCheckIfProfileExistsLazyQuery
>;
export type CheckIfProfileExistsSuspenseQueryHookResult = ReturnType<
  typeof useCheckIfProfileExistsSuspenseQuery
>;
export type CheckIfProfileExistsQueryResult = Apollo.QueryResult<
  CheckIfProfileExistsQuery,
  CheckIfProfileExistsQueryVariables
>;
export const ListPayoutHistoryDocument = gql`
    query ListPayoutHistory {
  listPayoutsHistory {
    ...Payout
  }
}
    ${PayoutFragmentDoc}`;

/**
 * __useListPayoutHistoryQuery__
 *
 * To run a query within a React component, call `useListPayoutHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPayoutHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPayoutHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useListPayoutHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<ListPayoutHistoryQuery, ListPayoutHistoryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListPayoutHistoryQuery, ListPayoutHistoryQueryVariables>(
    ListPayoutHistoryDocument,
    options,
  );
}
export function useListPayoutHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListPayoutHistoryQuery,
    ListPayoutHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListPayoutHistoryQuery, ListPayoutHistoryQueryVariables>(
    ListPayoutHistoryDocument,
    options,
  );
}
export function useListPayoutHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListPayoutHistoryQuery, ListPayoutHistoryQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListPayoutHistoryQuery, ListPayoutHistoryQueryVariables>(
    ListPayoutHistoryDocument,
    options,
  );
}
export type ListPayoutHistoryQueryHookResult = ReturnType<typeof useListPayoutHistoryQuery>;
export type ListPayoutHistoryLazyQueryHookResult = ReturnType<typeof useListPayoutHistoryLazyQuery>;
export type ListPayoutHistorySuspenseQueryHookResult = ReturnType<
  typeof useListPayoutHistorySuspenseQuery
>;
export type ListPayoutHistoryQueryResult = Apollo.QueryResult<
  ListPayoutHistoryQuery,
  ListPayoutHistoryQueryVariables
>;
export const ListPaymentHistoryDocument = gql`
    query ListPaymentHistory {
  listPaymentsHistory {
    ...Payment
  }
}
    ${PaymentFragmentDoc}`;

/**
 * __useListPaymentHistoryQuery__
 *
 * To run a query within a React component, call `useListPaymentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPaymentHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPaymentHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useListPaymentHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<ListPaymentHistoryQuery, ListPaymentHistoryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListPaymentHistoryQuery, ListPaymentHistoryQueryVariables>(
    ListPaymentHistoryDocument,
    options,
  );
}
export function useListPaymentHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListPaymentHistoryQuery,
    ListPaymentHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListPaymentHistoryQuery, ListPaymentHistoryQueryVariables>(
    ListPaymentHistoryDocument,
    options,
  );
}
export function useListPaymentHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListPaymentHistoryQuery, ListPaymentHistoryQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListPaymentHistoryQuery, ListPaymentHistoryQueryVariables>(
    ListPaymentHistoryDocument,
    options,
  );
}
export type ListPaymentHistoryQueryHookResult = ReturnType<typeof useListPaymentHistoryQuery>;
export type ListPaymentHistoryLazyQueryHookResult = ReturnType<
  typeof useListPaymentHistoryLazyQuery
>;
export type ListPaymentHistorySuspenseQueryHookResult = ReturnType<
  typeof useListPaymentHistorySuspenseQuery
>;
export type ListPaymentHistoryQueryResult = Apollo.QueryResult<
  ListPaymentHistoryQuery,
  ListPaymentHistoryQueryVariables
>;
export const GetMyReferralDocument = gql`
    query GetMyReferral {
  myReferral {
    ...Referral
  }
}
    ${ReferralFragmentDoc}`;

/**
 * __useGetMyReferralQuery__
 *
 * To run a query within a React component, call `useGetMyReferralQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyReferralQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyReferralQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyReferralQuery(
  baseOptions?: Apollo.QueryHookOptions<GetMyReferralQuery, GetMyReferralQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMyReferralQuery, GetMyReferralQueryVariables>(
    GetMyReferralDocument,
    options,
  );
}
export function useGetMyReferralLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMyReferralQuery, GetMyReferralQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMyReferralQuery, GetMyReferralQueryVariables>(
    GetMyReferralDocument,
    options,
  );
}
export function useGetMyReferralSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMyReferralQuery, GetMyReferralQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMyReferralQuery, GetMyReferralQueryVariables>(
    GetMyReferralDocument,
    options,
  );
}
export type GetMyReferralQueryHookResult = ReturnType<typeof useGetMyReferralQuery>;
export type GetMyReferralLazyQueryHookResult = ReturnType<typeof useGetMyReferralLazyQuery>;
export type GetMyReferralSuspenseQueryHookResult = ReturnType<typeof useGetMyReferralSuspenseQuery>;
export type GetMyReferralQueryResult = Apollo.QueryResult<
  GetMyReferralQuery,
  GetMyReferralQueryVariables
>;
export const GetAutoCompleteAddressDocument = gql`
    query GetAutoCompleteAddress($payload: GenerateAutocompleteForAddressInput!) {
  generateAutocompleteForAddress(payload: $payload) {
    ...AutoCompleteResponse
  }
}
    ${AutoCompleteResponseFragmentDoc}`;

/**
 * __useGetAutoCompleteAddressQuery__
 *
 * To run a query within a React component, call `useGetAutoCompleteAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoCompleteAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoCompleteAddressQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGetAutoCompleteAddressQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAutoCompleteAddressQuery,
    GetAutoCompleteAddressQueryVariables
  > &
    ({ variables: GetAutoCompleteAddressQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAutoCompleteAddressQuery, GetAutoCompleteAddressQueryVariables>(
    GetAutoCompleteAddressDocument,
    options,
  );
}
export function useGetAutoCompleteAddressLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAutoCompleteAddressQuery,
    GetAutoCompleteAddressQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAutoCompleteAddressQuery, GetAutoCompleteAddressQueryVariables>(
    GetAutoCompleteAddressDocument,
    options,
  );
}
export function useGetAutoCompleteAddressSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAutoCompleteAddressQuery,
        GetAutoCompleteAddressQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAutoCompleteAddressQuery, GetAutoCompleteAddressQueryVariables>(
    GetAutoCompleteAddressDocument,
    options,
  );
}
export type GetAutoCompleteAddressQueryHookResult = ReturnType<
  typeof useGetAutoCompleteAddressQuery
>;
export type GetAutoCompleteAddressLazyQueryHookResult = ReturnType<
  typeof useGetAutoCompleteAddressLazyQuery
>;
export type GetAutoCompleteAddressSuspenseQueryHookResult = ReturnType<
  typeof useGetAutoCompleteAddressSuspenseQuery
>;
export type GetAutoCompleteAddressQueryResult = Apollo.QueryResult<
  GetAutoCompleteAddressQuery,
  GetAutoCompleteAddressQueryVariables
>;
export const GetWorkerTimeStatsDocument = gql`
    query GetWorkerTimeStats($endDate: DateTime!, $startDate: DateTime!) {
  getWorkerTimeStats(endDate: $endDate, startDate: $startDate) {
    ...WorkerTimeStatsModel
  }
}
    ${WorkerTimeStatsModelFragmentDoc}`;

/**
 * __useGetWorkerTimeStatsQuery__
 *
 * To run a query within a React component, call `useGetWorkerTimeStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkerTimeStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkerTimeStatsQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetWorkerTimeStatsQuery(
  baseOptions: Apollo.QueryHookOptions<GetWorkerTimeStatsQuery, GetWorkerTimeStatsQueryVariables> &
    ({ variables: GetWorkerTimeStatsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWorkerTimeStatsQuery, GetWorkerTimeStatsQueryVariables>(
    GetWorkerTimeStatsDocument,
    options,
  );
}
export function useGetWorkerTimeStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkerTimeStatsQuery,
    GetWorkerTimeStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWorkerTimeStatsQuery, GetWorkerTimeStatsQueryVariables>(
    GetWorkerTimeStatsDocument,
    options,
  );
}
export function useGetWorkerTimeStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWorkerTimeStatsQuery, GetWorkerTimeStatsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetWorkerTimeStatsQuery, GetWorkerTimeStatsQueryVariables>(
    GetWorkerTimeStatsDocument,
    options,
  );
}
export type GetWorkerTimeStatsQueryHookResult = ReturnType<typeof useGetWorkerTimeStatsQuery>;
export type GetWorkerTimeStatsLazyQueryHookResult = ReturnType<
  typeof useGetWorkerTimeStatsLazyQuery
>;
export type GetWorkerTimeStatsSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkerTimeStatsSuspenseQuery
>;
export type GetWorkerTimeStatsQueryResult = Apollo.QueryResult<
  GetWorkerTimeStatsQuery,
  GetWorkerTimeStatsQueryVariables
>;
export const RegisterAccountDocument = gql`
    mutation RegisterAccount($email: String, $phoneNumber: String!) {
  registerAccountWithPhoneNumber(
    data: {email: $email, phone_number: $phoneNumber}
  )
}
    `;
export type RegisterAccountMutationFn = Apollo.MutationFunction<
  RegisterAccountMutation,
  RegisterAccountMutationVariables
>;

/**
 * __useRegisterAccountMutation__
 *
 * To run a mutation, you first call `useRegisterAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerAccountMutation, { data, loading, error }] = useRegisterAccountMutation({
 *   variables: {
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useRegisterAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterAccountMutation,
    RegisterAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RegisterAccountMutation, RegisterAccountMutationVariables>(
    RegisterAccountDocument,
    options,
  );
}
export type RegisterAccountMutationHookResult = ReturnType<typeof useRegisterAccountMutation>;
export type RegisterAccountMutationResult = Apollo.MutationResult<RegisterAccountMutation>;
export type RegisterAccountMutationOptions = Apollo.BaseMutationOptions<
  RegisterAccountMutation,
  RegisterAccountMutationVariables
>;
export const RegisterAccountWithGoogleDocument = gql`
    mutation RegisterAccountWithGoogle($data: RegisterAccountWithGoogleInput!) {
  registerAccountWithGoogle(data: $data)
}
    `;
export type RegisterAccountWithGoogleMutationFn = Apollo.MutationFunction<
  RegisterAccountWithGoogleMutation,
  RegisterAccountWithGoogleMutationVariables
>;

/**
 * __useRegisterAccountWithGoogleMutation__
 *
 * To run a mutation, you first call `useRegisterAccountWithGoogleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterAccountWithGoogleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerAccountWithGoogleMutation, { data, loading, error }] = useRegisterAccountWithGoogleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRegisterAccountWithGoogleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterAccountWithGoogleMutation,
    RegisterAccountWithGoogleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterAccountWithGoogleMutation,
    RegisterAccountWithGoogleMutationVariables
  >(RegisterAccountWithGoogleDocument, options);
}
export type RegisterAccountWithGoogleMutationHookResult = ReturnType<
  typeof useRegisterAccountWithGoogleMutation
>;
export type RegisterAccountWithGoogleMutationResult =
  Apollo.MutationResult<RegisterAccountWithGoogleMutation>;
export type RegisterAccountWithGoogleMutationOptions = Apollo.BaseMutationOptions<
  RegisterAccountWithGoogleMutation,
  RegisterAccountWithGoogleMutationVariables
>;
export const RegisterAccountWithFacebookDocument = gql`
    mutation RegisterAccountWithFacebook($data: RegisterAccountWithFacebookInput!) {
  registerAccountWithFacebook(data: $data)
}
    `;
export type RegisterAccountWithFacebookMutationFn = Apollo.MutationFunction<
  RegisterAccountWithFacebookMutation,
  RegisterAccountWithFacebookMutationVariables
>;

/**
 * __useRegisterAccountWithFacebookMutation__
 *
 * To run a mutation, you first call `useRegisterAccountWithFacebookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterAccountWithFacebookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerAccountWithFacebookMutation, { data, loading, error }] = useRegisterAccountWithFacebookMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRegisterAccountWithFacebookMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterAccountWithFacebookMutation,
    RegisterAccountWithFacebookMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterAccountWithFacebookMutation,
    RegisterAccountWithFacebookMutationVariables
  >(RegisterAccountWithFacebookDocument, options);
}
export type RegisterAccountWithFacebookMutationHookResult = ReturnType<
  typeof useRegisterAccountWithFacebookMutation
>;
export type RegisterAccountWithFacebookMutationResult =
  Apollo.MutationResult<RegisterAccountWithFacebookMutation>;
export type RegisterAccountWithFacebookMutationOptions = Apollo.BaseMutationOptions<
  RegisterAccountWithFacebookMutation,
  RegisterAccountWithFacebookMutationVariables
>;
export const LoginSendSmsCodeDocument = gql`
    mutation LoginSendSmsCode($phone_number: String!) {
  startLoginChallenge(data: {phone_number: $phone_number})
}
    `;
export type LoginSendSmsCodeMutationFn = Apollo.MutationFunction<
  LoginSendSmsCodeMutation,
  LoginSendSmsCodeMutationVariables
>;

/**
 * __useLoginSendSmsCodeMutation__
 *
 * To run a mutation, you first call `useLoginSendSmsCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginSendSmsCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginSendSmsCodeMutation, { data, loading, error }] = useLoginSendSmsCodeMutation({
 *   variables: {
 *      phone_number: // value for 'phone_number'
 *   },
 * });
 */
export function useLoginSendSmsCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LoginSendSmsCodeMutation,
    LoginSendSmsCodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LoginSendSmsCodeMutation, LoginSendSmsCodeMutationVariables>(
    LoginSendSmsCodeDocument,
    options,
  );
}
export type LoginSendSmsCodeMutationHookResult = ReturnType<typeof useLoginSendSmsCodeMutation>;
export type LoginSendSmsCodeMutationResult = Apollo.MutationResult<LoginSendSmsCodeMutation>;
export type LoginSendSmsCodeMutationOptions = Apollo.BaseMutationOptions<
  LoginSendSmsCodeMutation,
  LoginSendSmsCodeMutationVariables
>;
export const CreateWorkerProfileDocument = gql`
    mutation CreateWorkerProfile($data: CreateWorkerProfileInput!) {
  createWorkerProfile(data: $data)
}
    `;
export type CreateWorkerProfileMutationFn = Apollo.MutationFunction<
  CreateWorkerProfileMutation,
  CreateWorkerProfileMutationVariables
>;

/**
 * __useCreateWorkerProfileMutation__
 *
 * To run a mutation, you first call `useCreateWorkerProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkerProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkerProfileMutation, { data, loading, error }] = useCreateWorkerProfileMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateWorkerProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorkerProfileMutation,
    CreateWorkerProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateWorkerProfileMutation, CreateWorkerProfileMutationVariables>(
    CreateWorkerProfileDocument,
    options,
  );
}
export type CreateWorkerProfileMutationHookResult = ReturnType<
  typeof useCreateWorkerProfileMutation
>;
export type CreateWorkerProfileMutationResult = Apollo.MutationResult<CreateWorkerProfileMutation>;
export type CreateWorkerProfileMutationOptions = Apollo.BaseMutationOptions<
  CreateWorkerProfileMutation,
  CreateWorkerProfileMutationVariables
>;
export const CreateCustomerProfileDocument = gql`
    mutation CreateCustomerProfile($data: CreateCustomerProfileInput!) {
  createCustomerProfile(data: $data)
}
    `;
export type CreateCustomerProfileMutationFn = Apollo.MutationFunction<
  CreateCustomerProfileMutation,
  CreateCustomerProfileMutationVariables
>;

/**
 * __useCreateCustomerProfileMutation__
 *
 * To run a mutation, you first call `useCreateCustomerProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerProfileMutation, { data, loading, error }] = useCreateCustomerProfileMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCustomerProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCustomerProfileMutation,
    CreateCustomerProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCustomerProfileMutation, CreateCustomerProfileMutationVariables>(
    CreateCustomerProfileDocument,
    options,
  );
}
export type CreateCustomerProfileMutationHookResult = ReturnType<
  typeof useCreateCustomerProfileMutation
>;
export type CreateCustomerProfileMutationResult =
  Apollo.MutationResult<CreateCustomerProfileMutation>;
export type CreateCustomerProfileMutationOptions = Apollo.BaseMutationOptions<
  CreateCustomerProfileMutation,
  CreateCustomerProfileMutationVariables
>;
export const AssignWorkerToLocalizationDocument = gql`
    mutation AssignWorkerToLocalization($payload: AssignWorkerToLocalizationsDto!) {
  assignWorkerToLocalization(payload: $payload)
}
    `;
export type AssignWorkerToLocalizationMutationFn = Apollo.MutationFunction<
  AssignWorkerToLocalizationMutation,
  AssignWorkerToLocalizationMutationVariables
>;

/**
 * __useAssignWorkerToLocalizationMutation__
 *
 * To run a mutation, you first call `useAssignWorkerToLocalizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignWorkerToLocalizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignWorkerToLocalizationMutation, { data, loading, error }] = useAssignWorkerToLocalizationMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAssignWorkerToLocalizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignWorkerToLocalizationMutation,
    AssignWorkerToLocalizationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignWorkerToLocalizationMutation,
    AssignWorkerToLocalizationMutationVariables
  >(AssignWorkerToLocalizationDocument, options);
}
export type AssignWorkerToLocalizationMutationHookResult = ReturnType<
  typeof useAssignWorkerToLocalizationMutation
>;
export type AssignWorkerToLocalizationMutationResult =
  Apollo.MutationResult<AssignWorkerToLocalizationMutation>;
export type AssignWorkerToLocalizationMutationOptions = Apollo.BaseMutationOptions<
  AssignWorkerToLocalizationMutation,
  AssignWorkerToLocalizationMutationVariables
>;
export const UpdateWorkerProfileDocument = gql`
    mutation UpdateWorkerProfile($data: UpdateWorkerProfileInput!) {
  updateWorkerProfile(data: $data)
}
    `;
export type UpdateWorkerProfileMutationFn = Apollo.MutationFunction<
  UpdateWorkerProfileMutation,
  UpdateWorkerProfileMutationVariables
>;

/**
 * __useUpdateWorkerProfileMutation__
 *
 * To run a mutation, you first call `useUpdateWorkerProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkerProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkerProfileMutation, { data, loading, error }] = useUpdateWorkerProfileMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateWorkerProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWorkerProfileMutation,
    UpdateWorkerProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateWorkerProfileMutation, UpdateWorkerProfileMutationVariables>(
    UpdateWorkerProfileDocument,
    options,
  );
}
export type UpdateWorkerProfileMutationHookResult = ReturnType<
  typeof useUpdateWorkerProfileMutation
>;
export type UpdateWorkerProfileMutationResult = Apollo.MutationResult<UpdateWorkerProfileMutation>;
export type UpdateWorkerProfileMutationOptions = Apollo.BaseMutationOptions<
  UpdateWorkerProfileMutation,
  UpdateWorkerProfileMutationVariables
>;
export const UploadDocumentForVerificationDocument = gql`
    mutation UploadDocumentForVerification($data: UploadDocumentForVerificationInput!) {
  uploadDocumentForVerification(data: $data)
}
    `;
export type UploadDocumentForVerificationMutationFn = Apollo.MutationFunction<
  UploadDocumentForVerificationMutation,
  UploadDocumentForVerificationMutationVariables
>;

/**
 * __useUploadDocumentForVerificationMutation__
 *
 * To run a mutation, you first call `useUploadDocumentForVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDocumentForVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDocumentForVerificationMutation, { data, loading, error }] = useUploadDocumentForVerificationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUploadDocumentForVerificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadDocumentForVerificationMutation,
    UploadDocumentForVerificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadDocumentForVerificationMutation,
    UploadDocumentForVerificationMutationVariables
  >(UploadDocumentForVerificationDocument, options);
}
export type UploadDocumentForVerificationMutationHookResult = ReturnType<
  typeof useUploadDocumentForVerificationMutation
>;
export type UploadDocumentForVerificationMutationResult =
  Apollo.MutationResult<UploadDocumentForVerificationMutation>;
export type UploadDocumentForVerificationMutationOptions = Apollo.BaseMutationOptions<
  UploadDocumentForVerificationMutation,
  UploadDocumentForVerificationMutationVariables
>;
export const UpdateCustomerProfileDocument = gql`
    mutation UpdateCustomerProfile($data: UpdateCustomerProfileInput!) {
  updateCustomerProfile(data: $data)
}
    `;
export type UpdateCustomerProfileMutationFn = Apollo.MutationFunction<
  UpdateCustomerProfileMutation,
  UpdateCustomerProfileMutationVariables
>;

/**
 * __useUpdateCustomerProfileMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerProfileMutation, { data, loading, error }] = useUpdateCustomerProfileMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCustomerProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCustomerProfileMutation,
    UpdateCustomerProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCustomerProfileMutation, UpdateCustomerProfileMutationVariables>(
    UpdateCustomerProfileDocument,
    options,
  );
}
export type UpdateCustomerProfileMutationHookResult = ReturnType<
  typeof useUpdateCustomerProfileMutation
>;
export type UpdateCustomerProfileMutationResult =
  Apollo.MutationResult<UpdateCustomerProfileMutation>;
export type UpdateCustomerProfileMutationOptions = Apollo.BaseMutationOptions<
  UpdateCustomerProfileMutation,
  UpdateCustomerProfileMutationVariables
>;
export const UpdateProfileImageDocument = gql`
    mutation UpdateProfileImage($data: UpdateProfileImageInput!) {
  updateProfileImage(data: $data)
}
    `;
export type UpdateProfileImageMutationFn = Apollo.MutationFunction<
  UpdateProfileImageMutation,
  UpdateProfileImageMutationVariables
>;

/**
 * __useUpdateProfileImageMutation__
 *
 * To run a mutation, you first call `useUpdateProfileImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileImageMutation, { data, loading, error }] = useUpdateProfileImageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateProfileImageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProfileImageMutation,
    UpdateProfileImageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateProfileImageMutation, UpdateProfileImageMutationVariables>(
    UpdateProfileImageDocument,
    options,
  );
}
export type UpdateProfileImageMutationHookResult = ReturnType<typeof useUpdateProfileImageMutation>;
export type UpdateProfileImageMutationResult = Apollo.MutationResult<UpdateProfileImageMutation>;
export type UpdateProfileImageMutationOptions = Apollo.BaseMutationOptions<
  UpdateProfileImageMutation,
  UpdateProfileImageMutationVariables
>;
export const AddWorkerBankAccountDocument = gql`
    mutation AddWorkerBankAccount($data: AddBankAccountInput!) {
  addWorkerBankAccount(data: $data)
}
    `;
export type AddWorkerBankAccountMutationFn = Apollo.MutationFunction<
  AddWorkerBankAccountMutation,
  AddWorkerBankAccountMutationVariables
>;

/**
 * __useAddWorkerBankAccountMutation__
 *
 * To run a mutation, you first call `useAddWorkerBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkerBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkerBankAccountMutation, { data, loading, error }] = useAddWorkerBankAccountMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddWorkerBankAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddWorkerBankAccountMutation,
    AddWorkerBankAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddWorkerBankAccountMutation, AddWorkerBankAccountMutationVariables>(
    AddWorkerBankAccountDocument,
    options,
  );
}
export type AddWorkerBankAccountMutationHookResult = ReturnType<
  typeof useAddWorkerBankAccountMutation
>;
export type AddWorkerBankAccountMutationResult =
  Apollo.MutationResult<AddWorkerBankAccountMutation>;
export type AddWorkerBankAccountMutationOptions = Apollo.BaseMutationOptions<
  AddWorkerBankAccountMutation,
  AddWorkerBankAccountMutationVariables
>;
export const RemoveWorkerBankAccountDocument = gql`
    mutation RemoveWorkerBankAccount {
  removeWorkerBankAccount
}
    `;
export type RemoveWorkerBankAccountMutationFn = Apollo.MutationFunction<
  RemoveWorkerBankAccountMutation,
  RemoveWorkerBankAccountMutationVariables
>;

/**
 * __useRemoveWorkerBankAccountMutation__
 *
 * To run a mutation, you first call `useRemoveWorkerBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkerBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkerBankAccountMutation, { data, loading, error }] = useRemoveWorkerBankAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveWorkerBankAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveWorkerBankAccountMutation,
    RemoveWorkerBankAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveWorkerBankAccountMutation,
    RemoveWorkerBankAccountMutationVariables
  >(RemoveWorkerBankAccountDocument, options);
}
export type RemoveWorkerBankAccountMutationHookResult = ReturnType<
  typeof useRemoveWorkerBankAccountMutation
>;
export type RemoveWorkerBankAccountMutationResult =
  Apollo.MutationResult<RemoveWorkerBankAccountMutation>;
export type RemoveWorkerBankAccountMutationOptions = Apollo.BaseMutationOptions<
  RemoveWorkerBankAccountMutation,
  RemoveWorkerBankAccountMutationVariables
>;
export const SubmitWorkerPayoutDocument = gql`
    mutation SubmitWorkerPayout($data: SubmitPayoutInput!) {
  submitWorkerPayoutPayout(data: $data)
}
    `;
export type SubmitWorkerPayoutMutationFn = Apollo.MutationFunction<
  SubmitWorkerPayoutMutation,
  SubmitWorkerPayoutMutationVariables
>;

/**
 * __useSubmitWorkerPayoutMutation__
 *
 * To run a mutation, you first call `useSubmitWorkerPayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitWorkerPayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitWorkerPayoutMutation, { data, loading, error }] = useSubmitWorkerPayoutMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSubmitWorkerPayoutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitWorkerPayoutMutation,
    SubmitWorkerPayoutMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SubmitWorkerPayoutMutation, SubmitWorkerPayoutMutationVariables>(
    SubmitWorkerPayoutDocument,
    options,
  );
}
export type SubmitWorkerPayoutMutationHookResult = ReturnType<typeof useSubmitWorkerPayoutMutation>;
export type SubmitWorkerPayoutMutationResult = Apollo.MutationResult<SubmitWorkerPayoutMutation>;
export type SubmitWorkerPayoutMutationOptions = Apollo.BaseMutationOptions<
  SubmitWorkerPayoutMutation,
  SubmitWorkerPayoutMutationVariables
>;
export const DeleteProfileDocument = gql`
    mutation DeleteProfile {
  deleteProfile
}
    `;
export type DeleteProfileMutationFn = Apollo.MutationFunction<
  DeleteProfileMutation,
  DeleteProfileMutationVariables
>;

/**
 * __useDeleteProfileMutation__
 *
 * To run a mutation, you first call `useDeleteProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProfileMutation, { data, loading, error }] = useDeleteProfileMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteProfileMutation, DeleteProfileMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteProfileMutation, DeleteProfileMutationVariables>(
    DeleteProfileDocument,
    options,
  );
}
export type DeleteProfileMutationHookResult = ReturnType<typeof useDeleteProfileMutation>;
export type DeleteProfileMutationResult = Apollo.MutationResult<DeleteProfileMutation>;
export type DeleteProfileMutationOptions = Apollo.BaseMutationOptions<
  DeleteProfileMutation,
  DeleteProfileMutationVariables
>;
export const AttachDeviceToUserDocument = gql`
    mutation AttachDeviceToUser($data: PushNotificationDeviceInput!) {
  attachDeviceToUser(data: $data)
}
    `;
export type AttachDeviceToUserMutationFn = Apollo.MutationFunction<
  AttachDeviceToUserMutation,
  AttachDeviceToUserMutationVariables
>;

/**
 * __useAttachDeviceToUserMutation__
 *
 * To run a mutation, you first call `useAttachDeviceToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachDeviceToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachDeviceToUserMutation, { data, loading, error }] = useAttachDeviceToUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAttachDeviceToUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AttachDeviceToUserMutation,
    AttachDeviceToUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AttachDeviceToUserMutation, AttachDeviceToUserMutationVariables>(
    AttachDeviceToUserDocument,
    options,
  );
}
export type AttachDeviceToUserMutationHookResult = ReturnType<typeof useAttachDeviceToUserMutation>;
export type AttachDeviceToUserMutationResult = Apollo.MutationResult<AttachDeviceToUserMutation>;
export type AttachDeviceToUserMutationOptions = Apollo.BaseMutationOptions<
  AttachDeviceToUserMutation,
  AttachDeviceToUserMutationVariables
>;
export const DetachDeviceFromUserDocument = gql`
    mutation DetachDeviceFromUser($data: DetachPushNotificationDeviceInput!) {
  detachDeviceFromUser(data: $data)
}
    `;
export type DetachDeviceFromUserMutationFn = Apollo.MutationFunction<
  DetachDeviceFromUserMutation,
  DetachDeviceFromUserMutationVariables
>;

/**
 * __useDetachDeviceFromUserMutation__
 *
 * To run a mutation, you first call `useDetachDeviceFromUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachDeviceFromUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachDeviceFromUserMutation, { data, loading, error }] = useDetachDeviceFromUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDetachDeviceFromUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DetachDeviceFromUserMutation,
    DetachDeviceFromUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DetachDeviceFromUserMutation, DetachDeviceFromUserMutationVariables>(
    DetachDeviceFromUserDocument,
    options,
  );
}
export type DetachDeviceFromUserMutationHookResult = ReturnType<
  typeof useDetachDeviceFromUserMutation
>;
export type DetachDeviceFromUserMutationResult =
  Apollo.MutationResult<DetachDeviceFromUserMutation>;
export type DetachDeviceFromUserMutationOptions = Apollo.BaseMutationOptions<
  DetachDeviceFromUserMutation,
  DetachDeviceFromUserMutationVariables
>;
